import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useLocation, useParams } from 'react-router';
import { TeamRoleProvider } from '../../api/hooks/role.hooks';
import { PageHeader } from '../../components/header/page.header';
import { TeamSetup } from '../../components/team/team-setup';
import { useBeaconRouter } from '../../route/route.hooks';
import { logger } from '../../util/logger';
import { getPathIdParam } from '../../util/router';
import { TeamTabs } from './team.tabs';

interface RouteParams {
  id: string;
}

const TeamPage = (): ReactElement => {
  const { i18n } = useTranslation();
  const params = useParams<RouteParams>();
  const { id: teamId } = params;
  const location = useLocation();

  /**
   * TODO:
   * This code to extract the team id from the location object stems from an issue with useParams
   * not getting the current team id when navigating with direct links from bookmarks (in menu.tsx).
   *
   * The issue is seen when clicking a bookmarked menu item for a team tab different from the
   * current team location. The url looks correct, but the component rendered will attempt to use
   * the previous team id (useParams returns the previous team id).
   *
   * It would properly navigate if you were coming from a path of the same team.
   */
  const id = getPathIdParam('teams', teamId);

  const { builder } = useBeaconRouter();

  if (id === undefined || id === 'undefined') {
    logger.error('Team ID is undefined');
    return (
      <Redirect
        to={{
          pathname: builder.getHomeRoute(),
          state: { from: location },
        }}
      />
    );
  }

  if (id === 'new') {
    return (
      <IonPage>
        <PageHeader title={i18n.t('common:team_create')} />
        <IonContent>
          <TeamSetup />
        </IonContent>
      </IonPage>
    );
  } else {
    return (
      <TeamRoleProvider teamId={id}>
        <TeamTabs id={id} />
      </TeamRoleProvider>
    );
  }
};

export { TeamPage };
